<template>
  <router-link :to="linkDestination">
    <i :class="route.icon" />
    <span>{{ route.text }}</span>
    <span
      v-if="route.tag"
      class="chip"
    >Novidade</span>
  </router-link>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NavigationLink',
  props: {
    route: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      promoterID: (state) => state.user.userInfo.promoter_id,
    }),
    isFinanceiro() {
      return this.route.text === 'Financeiro';
    },
    linkDestination() {
      if (this.isFinanceiro) {
        return {
          name: 'promoters-commission',
          params: {
            id: this.promoterID ?? null,
          },
        };
      }
      return this.route.href;
    },
  },
};
</script>
